const validate = (value: string, { min }: Record<string, any>): boolean => {

    if (Number(value) === 0) {
        return true
    }

    return Number(value) >= Number(min)
}

export { validate }

export default {
    validate,
    params: [{
        name: 'min'
    }]
}
